export enum RecurringInvoiceDuration {
  Indefinite = 'INDEFINITE',
  Repeat = 'REPEAT',
}
